import { __extends, __spreadArray } from '../../../node_modules/tslib/tslib.es6.js';
import '../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../node_modules/lit-html/lit-html.js';
import '../../../node_modules/lit-element/lit-element.js';
import { dedupeMixin } from '../../../node_modules/@open-wc/dedupe-mixin/src/dedupeMixin.js';

/**
 * @template {Constructor<any>} TBase
 * @param {TBase} superclass
 * @return {TBase & Constructor<ScopedElementsHost>}
 */
function ScopedElementsMixinImplementation(superclass) {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(ScopedElementsHost, _super);
            function ScopedElementsHost() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(ScopedElementsHost, "scopedElements", {
                /**
                 * Obtains the scoped elements definitions map if specified.
                 * If scoped elements are required, this will be overridden in the component.
                 *
                 * @returns {ScopedElementsMap}
                 */
                get: function () {
                    return {};
                },
                enumerable: false,
                configurable: true
            });
            ScopedElementsHost.prototype.firstUpdated = function () {
                var scopedElements = this.constructor.scopedElements;
                for (var _i = 0, _a = Object.entries(scopedElements); _i < _a.length; _i++) {
                    var _b = _a[_i], tagName = _b[0], klass = _b[1];
                    this.defineScopedElement(tagName, klass);
                }
                _super.prototype.firstUpdated.call(this);
                // let's trigger a repaint to ensure the scoped tags are used
                this.requestUpdate();
            };
            /**
             * Defines a scoped element.
             *
             * @param {string} tagName
             * @param {CustomElementConstructor} klass
             */
            ScopedElementsHost.prototype.defineScopedElement = function (tagName, klass) {
                var _a = this.constructor, namespace = _a.namespace, scopedTagList = _a.scopedTagList;
                var scopedTag = scopedTagList.get("".concat(namespace, "_").concat(tagName));
                if (scopedTag) {
                    return scopedTag;
                }
                // create a scoped version of the tag name with a random number at the end
                var randomSuffix = function () { return Math.round(Math.random() * 88888888 + 11111111).toString(); };
                var scopedTagName = "".concat(tagName, "-").concat(randomSuffix());
                while (customElements.get(scopedTagName)) {
                    scopedTagName = "".concat(tagName, "-").concat(randomSuffix());
                }
                // add scoped tag to internal dictionary
                scopedTagList.set("".concat(namespace, "_").concat(tagName), scopedTagName);
                // register the component with the new scoped tag
                // the same constructor cannot be used multiple times so we have to extend it just in case
                customElements.define(scopedTagName, /** @class */ (function (_super) {
                    __extends(class_1, _super);
                    function class_1() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    return class_1;
                }(klass)));
            };
            /**
             * This method is a template tag that is used to preprocess an HTML template for use in
             * Lit's html template tag in order to replace scoped components with their scoped tag names.
             * The scoped HTML will then be passed through Lit's html template tag (used as a regular function)
             * in order to transform it for use in Lit.
             * @param strings the template strings broken down
             * @param _ spread of the properties passed into the template tag that need to be passed to html
             * @returns TemplateResult (generated by the html template tag)
             */
            ScopedElementsHost.prototype.scopeTemplate = function (strings) {
                var _this = this;
                var _ = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    _[_i - 1] = arguments[_i];
                }
                // create original tag names and regexes once ahead of time for reuse
                // @ts-ignore
                var scopedHelpers = Array.from(this.constructor.scopedTagList).map(function (_a) {
                    var namespacedOgTagName = _a[0], scopedTagName = _a[1];
                    // @ts-ignore
                    var ogTagName = namespacedOgTagName.replace("".concat(_this.constructor.namespace, "_"), '');
                    return {
                        ogTagName: ogTagName,
                        scopedTagName: scopedTagName,
                        ogOpeningTagRegex: new RegExp("<".concat(ogTagName), 'igm'),
                        ogClosingTagRegex: new RegExp("</".concat(ogTagName), 'igm'),
                    };
                });
                // we'll loop through all of the scoped components and update their tags in the template
                var mappedStrings = strings.map(function (scopedString) {
                    Array.from(scopedHelpers).forEach(function (_a) {
                        var ogTagName = _a.ogTagName, scopedTagName = _a.scopedTagName, ogOpeningTagRegex = _a.ogOpeningTagRegex, ogClosingTagRegex = _a.ogClosingTagRegex;
                        scopedString = scopedString
                            .replace(ogOpeningTagRegex, "<".concat(scopedTagName, " data-tag-name=\"").concat(ogTagName, "\""))
                            .replace(ogClosingTagRegex, "</".concat(scopedTagName));
                    });
                    return scopedString;
                });
                // we need to add the immutable raw property so that the array properly conforms to the expected type
                // for Lit's html template tag
                Object.defineProperty(mappedStrings, 'raw', {
                    value: __spreadArray([], mappedStrings, true),
                    writable: false,
                });
                return x.apply(void 0, __spreadArray([mappedStrings], _, false));
            };
            return ScopedElementsHost;
        }(superclass)),
        /**
         * Stores the mapping of namespaced scoped elements. We store them with the namespace
         * because there may be a case where a component is defined with multiple namespaces.
         */
        _a.scopedTagList = new Map(),
        _a;
}
var ScopedElementsMixin = dedupeMixin(ScopedElementsMixinImplementation);

export { ScopedElementsMixin };
